<mat-tab-group headerPosition="below" animationDuration="0ms">
  <mat-tab *ngFor="let worksheet of workbook?.worksheets" [label]="worksheet.name">
    <ng-template matTabContent>
      <red-exceljs-worksheet [worksheet]="worksheet"></red-exceljs-worksheet>
    </ng-template>
  </mat-tab>
</mat-tab-group>
